import { isNullish } from '@/utils/helper'
import XLSX from 'xlsx'
import ExcelJS from 'exceljs'

export const createExcelBlob = (excelData) => {
  if (!Array.isArray(excelData)) {
    return null
  }

  //for dateformat in excelData, change to DD-MM-YYYY
  excelData.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (key.includes('Date') || key.includes('date') || key.includes('createdAt') || key.includes('updatedAt')) {
        row[key] = row[key].split('T')[0]
      }
    })
  })

  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.json_to_sheet(excelData)

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  // Convert the workbook to a blob
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const excelBlob = new Blob([new Uint8Array(wbout)], {
    type: 'application/octet-stream',
  })

  return excelBlob
}

export const getFileExtension = (filename) => {
  if (isNullish(filename)) {
    return ''
  }
  const parts = filename.split('.')
  if (parts.length > 1) {
    return parts.pop()
  } else {
    return ''
  }
}

export const createExcelWithOptions = async (header, data, optionConfigs) => {
  if (!Array.isArray(data)) {
    return null
  }

  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('Sheet1')

  // Add headers
  worksheet.columns = header

  data.forEach((item) => worksheet.addRow(item))

  // Define dropdown options
  for (const { options, columnKey } of optionConfigs) {
    // Apply dropdown to cells
    const safeOptions = options.map((opt) => opt.replace(/"/g, '""').replace(/,/g, ''))

    if (options.length > 0 && columnKey !== '') {
      const listSheet = workbook.addWorksheet('DropdownOptions_' + columnKey)
      listSheet.state = 'veryHidden'

      safeOptions.forEach((opt, i) => {
        listSheet.getCell(`A${i + 1}`).value = opt
      })

      for (let i = 2; i <= data.length + 1; i++) {
        worksheet.getCell(`${columnKey}${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`DropdownOptions_${columnKey}!$A$1:$A$22`],
        }
      }
    }
  }

  // Generate Excel file and trigger download
  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

  return blob
}
